import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import moment from 'moment';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import PageTracker from '../../../common/PageTrackerHelper'
import {
  BasicSelect
} from 'vue-search-select';
import keycloak from '../../../common/Keycloak';

export default {
  name: 'SRAvailability',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect,
    BasicSelect
  },
  mixins:[PageTracker],
  data: function() {
    return {
      pageno: 0,
      pagecount: 0,
      localhubdetails:'',
      localuserid:'',
      srArrayList: [],
      IscheckedSRList: [],
      isTripAllowedForSR: '',
      isSRTripLoader: false,
      SendDetailsloader: false,
      search: '',
      isLoading: false,
      ShippingID:'',
      selectedItems:[],
      selectedItemdata:'',
      allship: [],
      ShiftLoader:'',
      userDataKey : '',
    }
  },
  created: function() {
  },
  computed: {
    filteredSRList:function() {
        var self=this;
        return this.srArrayList.filter(function(emp){
          if(emp.DeliverySRName.toLowerCase().indexOf(self.search.toLowerCase())>=0){
            return emp.DeliverySRName.toLowerCase().indexOf(self.search.toLowerCase())>=0;
          } else if(emp.DeliverySRIds.toLowerCase().indexOf(self.search.toLowerCase())>=0){
            return emp.DeliverySRIds.toLowerCase().indexOf(self.search.toLowerCase())>=0;
          }
        });
        //return this.customers;
     }
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let setLocusFlag = await this.checkIsLocusEnableforhub()
    if(!setLocusFlag) {
      this.$alertify.error('Your are not authorized user/hub for locus module.!')
      this.$router.push('/dashboard')
      return false;
    }
    console.log('setLocusFlag SRAvailability----->>', setLocusFlag);

    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.loadSRList();

    let TrackerInfo = {
        projectname:"Last Mile",
        type:"Web",
        userid:this.localuserid,
        username:this.localusermailid,
        meta: {
            "event":""
        }
    }
    let result  = this.PageTracker(TrackerInfo);
  },
  filters: {
    changeDateFormat: function(date) {
      if (typeof date === "object" && !date) {
        return '';
      } else {
        return moment(date).format('DD-MM-YYYY HH:mm:ss');
      }
    }
  },
  methods: {
    selectItems(ev) {
      this.selectedItems = [];
      if (ev.target.checked == true) {
        for (let i in this.filteredSRList) {
          this.selectedItems.push(this.filteredSRList[i].userid);
        }
      }else{
        for (let i in this.filteredSRList) {
          this.selectedItems.pop(this.filteredSRList[i].userid);
        }
      }
    },

    setcheckbox($event,userid) {
      if ($event.target.checked == true) {
        if(!this.selectedItems.includes(userid)){
          this.selectedItems.push(userid);
        }
      }
      else{
        if(this.selectedItems.includes(userid)){
          this.selectedItems.pop(userid);
        }
      }
      if(this.selectedItems.length == 0){
        this.selectedItemdata = false
      }
    },

    ShowSendDetails(){
      this.SendDetailsloader = true;

      if(this.selectedItems.length == 0){
        this.$alertify.error("Please select at least one SR.");
        return;
      }

      let payload = {
        "SRIds" : this.selectedItems,
        "hubID" : this.localhubdetails,
        "LastModifiedBy" : this.localusermailid
      }
      axios({
        method: 'POST',
        url: apiUrl.api_url + 'locus/sendsravailabilty',
        data: payload
      })
      .then(result => {
        if (result.data.code==200 && result.data.data!= null) {
          this.$alertify.success("SR availability details send successfully");
        } else {
          this.$alertify.error(result.data.message);
        }
        this.resetForm();
        this.SendDetailsloader = false;
        this.selectedItems = [];
      }, error => {
        console.error(error)
      })
    },

    loadSRList() {
      this.isLoading = true;
      this.srArrayList = []
      this.srList = []
      if(this.localhubdetails) {
        this.input = {
          "usertype":"3",
        	"hubid":[this.localhubdetails]
        }
        let apiendpoint = 'expose/users/HubDeliveryUsers/get/List';
        if (keycloak.enableKavach) {
            apiendpoint = 'user/migration/gethubdeliveryuserlist';
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + apiendpoint,
          data: this.input
        })
        .then(result => {
          if (result.data.data.code == 200) {
            let getResponse = result.data.data.results;
            let cnt = getResponse.length;
            for (var i = 0; i < cnt; i++) {
              let obj = {};
              obj.DeliverySRName = `${getResponse[i].FirstName} ${getResponse[i].LastName}`;
              obj.DeliverySRIds = `( ${getResponse[i].OldDeliveryUserOrUserId} - ${getResponse[i].userid} )`;
              obj.userid = getResponse[i].userid;
              obj.OldDeliveryUserOrUserId = getResponse[i].OldDeliveryUserOrUserId;
              obj.modifieddatetime = getResponse[i].modifieddatetime;
              obj.lastmodifiedby = getResponse[i].lastmodifiedby;
              obj.isTripAllowedForSR = getResponse[i].isTripAllowedForSR;
              this.srArrayList.push(obj);
              if(getResponse[i].isTripAllowedForSR == true) {
                this.IscheckedSRList.push(getResponse[i].userid)
              }
            }
          } else {
            this.$alertify.error(result.data.data.message?result.data.data.message:'No Record found')
          }
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
      } else {
        this.$alertify.error("Current Hub Id not found.")
      }
    },

    resetForm() {
      this.hubname = this.localhubdetails;
      this.pageno = 1;
      this.search = '';
      this.selectedItems = '';
      this.selectedItemdata = '';
      this.errors.clear();
      this.$validator.reset();
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/SRAvailability/SRAvailability.component.js